<div class="all-progress" [ngClass]="withMargin ? 'withMargin' : 'withoutMargin'">
    <div class="step-container">
        <ng-container *ngFor="let step of steps; let i = index">
            <div class="step">
                <div class="circle" [ngClass]="{
                    'active': currentStep > i,
                    'current': currentStep === i,
                    'dotted': currentStep < i
                    }">
                    <svg *ngIf="currentStep > i" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2" viewBox="0 0 16 16">
                        <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                    </svg>
                    <svg *ngIf="currentStep === i" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-check2" viewBox="0 0 16 16">
                        <path d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0" />
                    </svg>
                </div>
                <div class="f-title">
                    <p>{{ step.title }}</p>
                </div>
            </div>
            <!-- Line segment between each step -->
            <div class="line-segment" *ngIf="i < steps.length - 1" 
                 [ngClass]="{'active': currentStep > i}"
                 >
            </div>
        </ng-container>
    </div>
</div>
